<div #section
    id="topics"
    class="agpr-userPreferences-subSection"
>
    <h4 class="agpr-userPreferences-subSection-heading">
        {{ 'UserPreferences.topics' | localize}}
    </h4>

    <div class="agpr-userPreferences-subSection-content">
        <agpr-user-preference-filter-wrapper
            [id]="'monitor_userPreferences_topics_filters'"
            [items]="topics"
            [initialValues]="monitoringPreferences.topicsPrefs.defaultFilters"
            [defaultFilters]="defaultTopicsFilters"
            (filterChange)="updateDirtyFlag()"
        ></agpr-user-preference-filter-wrapper>
    </div>

    <div class="agpr-userPreferences-subSection-content">
        <h5 class="agpr-userPreferences-subSection-subHeading">
            {{'AccountPreferences.defaultResults' | localize}}
        </h5>
        <div class="agpr-monitorPreferences-results">
            <div class="agpr-monitorPreferences-results-check">
                <div class="agpr-monitorPreferences-results-radio">
                    <h6 class="agpr-monitorPreferences-results-dropdown-label"> {{ 'Monitor.userPreferences.defaultSearch.defaultViewMode' | localize }} </h6>
                    <agpr-radio
                        [id]="'agpr_monitorPreferences_viewMode_analytics'"
                        label="Monitor.userPreferences.defaultSearch.defaultViewMode.analytics"
                        [(ngModel)]="topicsDisplaySettings.resultsViewMode"
                        [value]="resultsViewModeEnum.DASHBOARD"
                        (ngModelChange)="updateDirtyFlag()"
                        hiddenLabel="Monitor.userPreferences.corporateTemplateLabel"
                    ></agpr-radio>
                    <agpr-radio
                        [id]="'agpr_monitorPreferences_viewMode_mentionFeed'"
                        [(ngModel)]="topicsDisplaySettings.resultsViewMode"
                        label="Monitor.userPreferences.defaultSearch.defaultViewMode.mention"
                        [value]="resultsViewModeEnum.MENTION"
                        (ngModelChange)="updateDirtyFlag()"
                        hiddenLabel="Monitor.userPreferences.corporateTemplateLabel"
                    ></agpr-radio>
                </div>
                <agpr-checkbox
                    [id]="'topicPreferences_showImage_checkbox'"
                    label="Monitor.userPreferences.defaultSearch.showImage"
                    [binary]="true"
                    [(ngModel)]="topicsDisplaySettings.showImages"
                    (ngModelChange)="updateDirtyFlag()"
                ></agpr-checkbox>
                <agpr-checkbox
                    [id]="'topicPreferences_showIndex_checkbox'"
                    label="Monitor.userPreferences.defaultSearch.showMention"
                    [binary]="true"
                    [(ngModel)]="topicsDisplaySettings.showMentionIndex"
                    (ngModelChange)="updateDirtyFlag()"
                    ></agpr-checkbox>
                <agpr-checkbox
                    [id]="'topicPreferences_compactDisplay_checkbox'"
                    label="Monitor.userPreferences.defaultSearch.compactMention"
                    [binary]="true"
                    [(ngModel)]="topicsDisplaySettings.isCompactMentionDisplay"
                    (ngModelChange)="updateDirtyFlag()"
                ></agpr-checkbox>
            </div>
            <div class="agpr-monitorPreferences-results-dropdowns">
                <div>
                    <div class="agpr-monitorPreferences-results-dropdown-label">
                        {{ 'AccountPreferences.defaultResults.sortOrder' | localize }}
                    </div>
                    <div class="agpr-monitorPreferences-results-dropdown">
                        <agpr-dropdown
                            [id]="'savedSearches_topics_sort_dropdown_type'"
                            placeholder="AccountPreferences.defaultResults.sortType"
                            [options]="topicsDisplaySettings.sortTypeOptions"
                            [(ngModel)]="topicsDisplaySettings.selectedSortType"
                            (ngModelChange)="topicsDisplaySettings.handleSelectionChange($event, 'type'); updateDirtyFlag()"
                            label="AccountPreferences.defaultResults.sortType"
                        ></agpr-dropdown>
                        <agpr-dropdown
                            [id]="'savedSearches_topics_sort_dropdown_order'"
                            class="agpr-monitorPreferences-results-dropdown-sortDirection"
                            placeholder="AccountPreferences.defaultResults.sortDirection"
                            [options]="topicsDisplaySettings.sortDirectionOptions"
                            [(ngModel)]="topicsDisplaySettings.selectedSortDirection"
                            (ngModelChange)="topicsDisplaySettings.handleSelectionChange($event, 'direction'); updateDirtyFlag()"
                            label="AccountPreferences.defaultResults.sortDirection"
                        ></agpr-dropdown>
                    </div>
                </div>
                <div>
                    <agpr-dropdown
                        [id]="'savedSearches_topics_page_dropdown'"
                        placeholder="AccountPreferences.defaultResults.pageSize"
                        [options]="topicsDisplaySettings.pageSizeOptions"
                        [(ngModel)]="topicsDisplaySettings.selectedPageSize"
                        (ngModelChange)="topicsDisplaySettings.handleSelectionChange($event, 'pageSize'); updateDirtyFlag()"
                        label="AccountPreferences.defaultResults.pageSize"
                    ></agpr-dropdown>
                </div>
            </div>
        </div>
    </div>


</div>
<div #section
    id="folders"
    class="agpr-userPreferences-subSection"
>
    <h4 class="agpr-userPreferences-subSection-heading">
        {{ 'UserPreferences.folders' | localize}}
    </h4>

    <div class="agpr-userPreferences-subSection-content">
        <agpr-user-preference-filter-wrapper
            [id]="'monitor_userPreferences_folder_filters'"
            [items]="folders"
            [initialValues]="monitoringPreferences.savedCoveragePrefs.defaultFilters"
            [defaultFilters]="defaultSavedCoverageFilters"
            (filterChange)="updateDirtyFlag()"
        ></agpr-user-preference-filter-wrapper>
    </div>

    <div class="agpr-userPreferences-subSection-content">
        <h5 class="agpr-userPreferences-subSection-subHeading">
            {{'AccountPreferences.defaultResults' | localize}}
        </h5>
        <div class="agpr-monitorPreferences-results">
            <div class="agpr-monitorPreferences-results-check">
                <div class="agpr-monitorPreferences-results-radio">
                    <h6 class="agpr-monitorPreferences-results-dropdown-label"> {{ 'Monitor.userPreferences.defaultSearch.defaultViewMode' | localize }} </h6>
                    <agpr-radio
                        [id]="'folderPreferences_viewMode_analytics'"
                        label="Monitor.userPreferences.defaultSearch.defaultViewMode.analytics"
                        [(ngModel)]="savedCoverageDisplaySettings.resultsViewMode"
                        [value]="resultsViewModeEnum.DASHBOARD"
                        (ngModelChange)="updateDirtyFlag()"
                    ></agpr-radio>
                    <agpr-radio
                        [id]="'folderPreferences_viewMode_mentionFeed'"
                        [(ngModel)]="savedCoverageDisplaySettings.resultsViewMode"
                        label="Monitor.userPreferences.defaultSearch.defaultViewMode.mention"
                        [value]="resultsViewModeEnum.MENTION"
                        (ngModelChange)="updateDirtyFlag()"
                    ></agpr-radio>
                </div>
                <agpr-checkbox
                    [id]="'folderPreferences_showImage_checkbox'"
                    label="Monitor.userPreferences.defaultSearch.showImage"
                    [binary]="true"
                    [(ngModel)]="savedCoverageDisplaySettings.showImages"
                    (ngModelChange)="updateDirtyFlag()"
                ></agpr-checkbox>
                <agpr-checkbox
                    [id]="'folderPreferences_showIndex_checkbox'"
                    label="Monitor.userPreferences.defaultSearch.showMention"
                    [binary]="true"
                    [(ngModel)]="savedCoverageDisplaySettings.showMentionIndex"
                    (ngModelChange)="updateDirtyFlag()"
                ></agpr-checkbox>
                <agpr-checkbox
                    [id]="'folderPreferences_compactDisplay_checkbox'"
                    label="Monitor.userPreferences.defaultSearch.compactMention"
                    [binary]="true"
                    [(ngModel)]="savedCoverageDisplaySettings.isCompactMentionDisplay"
                    (ngModelChange)="updateDirtyFlag()"
                ></agpr-checkbox>
            </div>
            <div class="agpr-monitorPreferences-results-dropdowns">
                <div>
                    <div class="agpr-monitorPreferences-results-dropdown-label">
                        {{ 'AccountPreferences.defaultResults.sortOrder' | localize }}
                    </div>
                    <div class="agpr-monitorPreferences-results-dropdown">
                        <agpr-dropdown
                            [id]="'savedSearches_folders_sort_dropdown_type'"
                            placeholder="AccountPreferences.defaultResults.sortType"
                            [options]="savedCoverageDisplaySettings.sortTypeOptions"
                            [(ngModel)]="savedCoverageDisplaySettings.selectedSortType"
                            (ngModelChange)="savedCoverageDisplaySettings.handleSelectionChange($event, 'type'); updateDirtyFlag()"
                            label="AccountPreferences.defaultResults.sortType"
                        ></agpr-dropdown>
                        <agpr-dropdown
                            [id]="'savedSearches_folders_sort_dropdown_order'"
                            class="agpr-monitorPreferences-results-dropdown-sortDirection"
                            placeholder="AccountPreferences.defaultResults.sortDirection"
                            [options]="savedCoverageDisplaySettings.sortDirectionOptions"
                            [(ngModel)]="savedCoverageDisplaySettings.selectedSortDirection"
                            (ngModelChange)="savedCoverageDisplaySettings.handleSelectionChange($event, 'direction'); updateDirtyFlag()"
                            label="AccountPreferences.defaultResults.sortDirection"
                        ></agpr-dropdown>
                    </div>
                </div>
                <div>
                    <agpr-dropdown
                        [id]="'savedSearches_folders_page_dropdown'"
                        placeholder="AccountPreferences.defaultResults.pageSize"
                        [options]="savedCoverageDisplaySettings.pageSizeOptions"
                        [(ngModel)]="savedCoverageDisplaySettings.selectedPageSize"
                        (ngModelChange)="savedCoverageDisplaySettings.handleSelectionChange($event, 'pageSize'); updateDirtyFlag()"
                        label="AccountPreferences.defaultResults.pageSize"
                    ></agpr-dropdown>
                </div>
            </div>
        </div>
    </div>
</div>

<div #section
    id="briefings"
    class="agpr-userPreferences-subSection"
>
    <h4 class="agpr-userPreferences-subSection-heading">
        {{ 'UserPreferences.briefings' | localize}}
    </h4>

    <div class="agpr-userPreferences-subSection-content">
        <agpr-user-preference-filter-wrapper
            [id]="'monitor_userPreferences_briefings_filters'"
            [items]="briefings"
            [initialValues]="monitoringPreferences.briefingsPrefs.defaultFilters"
            [defaultFilters]="defaultBriefingsFilters"
            (filterChange)="updateDirtyFlag()"
        ></agpr-user-preference-filter-wrapper>
    </div>

    <div class="agpr-userPreferences-subSection-content">
        <h5 class="agpr-userPreferences-subSection-subHeading">
            {{'Monitor.userPreferences.defaultBriefingTemplate' | localize}}
        </h5>
        <div
            class="agpr-monitorPreferences-template-templateSelection"
            role="radiogroup"
            [attr.aria-label]="'Monitor.userPreferences.defaultBriefingTemplate' | localize"
        >
            <div class="agpr-monitorPreferences-template-templateSelectionDefault">
                <div class="agpr-monitorPreferences-template-templateSelectionDefaultChoice">
                    <agpr-radio
                        [id]="'agpr_monitorPreferences_chooseDefaultTemplate1'"
                        [(ngModel)]="briefingTemplateSelection"
                        [value]="defaultBriefingTemplateOptions.one"
                        (ngModelChange)="updateDirtyFlag()"
                        hiddenLabel="Monitor.userPreferences.corporateTemplateLabel"
                    ></agpr-radio>
                    <button
                        class="agpr-monitorPreferences-template-templateSelectionThumbnail"
                        [ngClass]="{
                            'agpr-monitorPreferences-template-templateSelectionThumbnail--focused': briefingTemplateSelection === defaultBriefingTemplateOptions.one
                        }"
                        [tabindex]="briefingTemplateSelection === defaultBriefingTemplateOptions.one ? '0' : '-1'"
                        [attr.aria-label]="'Briefings.createDialog.preview' | localize"
                        (click)="preview(appBaseHref + 'assets/images/BriefingPreviewA.jpg')"
                    >
                        <img
                            [src]="appBaseHref + 'assets/images/BriefingPreviewAThumbnail.jpg'"
                            [alt]="'Monitor.userPreferences.corporateTemplateLabel' | localize"
                            height="100"
                            width="100"
                        />
                        <span class="agpr-monitorPreferences-template-templateSelectionPreview fa-regular fa-duotone fa-magnifying-glass-plus"></span>
                    </button>
                </div>
                <div class="agpr-monitorPreferences-template-templateSelectionDefaultChoice">
                    <agpr-radio
                        [id]="'agpr_monitorPreferences_chooseDefaultTemplate2'"
                        [(ngModel)]="briefingTemplateSelection"
                        [value]="defaultBriefingTemplateOptions.two"
                        (ngModelChange)="updateDirtyFlag()"
                        hiddenLabel="Monitor.userPreferences.vividTemplateLabel"
                    ></agpr-radio>
                    <button
                        class="agpr-monitorPreferences-template-templateSelectionThumbnail"
                        [ngClass]="{
                            'agpr-monitorPreferences-template-templateSelectionThumbnail--focused': briefingTemplateSelection === defaultBriefingTemplateOptions.two
                        }"
                        [tabindex]="briefingTemplateSelection === defaultBriefingTemplateOptions.two ? '0' : '-1'"
                        [attr.aria-label]="'Briefings.createDialog.preview' | localize"
                        (click)="preview(appBaseHref + 'assets/images/BriefingPreviewB.jpg')"
                    >
                        <img
                            [src]="appBaseHref + 'assets/images/BriefingPreviewBThumbnail.jpg'"
                            [alt]="'Monitor.userPreferences.vividTemplateLabel' | localize"
                            height="100"
                            width="100"
                        />
                        <span class="agpr-monitorPreferences-template-templateSelectionPreview fa-regular fa-duotone fa-magnifying-glass-plus"></span>
                    </button>
                </div>
                <div class="agpr-monitorPreferences-template-templateSelectionDefaultChoice">
                    <agpr-radio
                        [id]="'agpr_monitorPreferences_chooseDefaultTemplate3'"
                        [(ngModel)]="briefingTemplateSelection"
                        [value]="defaultBriefingTemplateOptions.three"
                        (ngModelChange)="updateDirtyFlag()"
                        hiddenLabel="Monitor.userPreferences.minimalistTemplateLabel"
                    ></agpr-radio>
                    <button
                        class="agpr-monitorPreferences-template-templateSelectionThumbnail"
                        [ngClass]="{
                            'agpr-monitorPreferences-template-templateSelectionThumbnail--focused': briefingTemplateSelection === defaultBriefingTemplateOptions.three
                        }"
                        [tabindex]="briefingTemplateSelection === defaultBriefingTemplateOptions.three ? '0' : '-1'"
                        [attr.aria-label]="'Briefings.createDialog.preview' | localize"
                        (click)="preview(appBaseHref + 'assets/images/BriefingPreviewC.jpg')"
                    >
                        <img
                            [src]="appBaseHref + 'assets/images/BriefingPreviewCThumbnail.jpg'"
                            [alt]="'Monitor.userPreferences.minimalistTemplateLabel' | localize"
                            height="100"
                            width="100"
                        />
                        <span class="agpr-monitorPreferences-template-templateSelectionPreview fa-regular fa-duotone fa-magnifying-glass-plus"></span>
                    </button>
                </div>
            </div>
            <agpr-radio
                [id]="'agpr_monitorPreferences_chooseSavedTemplate'"
                [label]="'Briefings.createDialog.savedTemplate'"
                [hiddenLabel]="'Briefings.createDialog.savedTemplate'"
                [(ngModel)]="briefingTemplateSelection"
                [value]="defaultBriefingTemplateOptions.saved"
                (ngModelChange)="updateDirtyFlag()"
            ></agpr-radio>
            <div class="agpr-monitorPreferences-template-templateSelectionSaved agpr-inputGroupRow">
                <agpr-dropdown
                    [id]="'briefing_savedTemplate_dropdown'"
                    class="agpr-inputGroupRow-dropdown"
                    [disabled]="briefingTemplateSelection !== defaultBriefingTemplateOptions.saved"
                    placeholder="Briefings.createDialog.selectTemplatePlaceholder"
                    ariaLabel="Briefings.createDialog.savedTemplate"
                    [options]="briefingTemplateListItems"
                    [optionLabel]="'name'"
                    [(ngModel)]="selectedBriefingTemplateDropdown"
                    (ngModelChange)="updateDirtyFlag()"
                ></agpr-dropdown>
                <agpr-button
                    [id]="'agpr_monitorPreferences_manageTemplates'"
                    class="agpr-inputGroupRow-buttons"
                    [disabled]="briefingTemplateSelection !== defaultBriefingTemplateOptions.saved"
                    icon="fa-regular fa-duotone fa-gear"
                    [style]="buttonTypes.icon"
                    (click)="manageTemplatesButtonClicked()"
                ></agpr-button>
            </div>
        </div>
        <div>
            <h5 class="agpr-userPreferences-subSection-subHeading">
                {{ 'AccountPreferences.defaultResults' | localize }}
            </h5>
            <div class="agpr-monitorPreferences-results-dropdowns">
                <div class="agpr-monitorPreferences-results-dropdown-label">
                    {{ 'AccountPreferences.defaultResults.pageSize' | localize }}
                </div>
                <agpr-dropdown
                    [id]="'agpr_monitorPreferences_briefings_page_dropdown'"
                    class="agpr-monitorPreferences-dropdown-mini"
                    placeholder="AccountPreferences.defaultResults.pageSize"
                    [options]="briefingDisplaySettings.pageSizeOptions"
                    [(ngModel)]="briefingDisplaySettings.selectedPageSize"
                    (ngModelChange)="updateDirtyFlag()"
                    [ariaLabel]="'AccountPreferences.defaultResults.pageSize'"
                ></agpr-dropdown>
            </div>
        </div>
    </div>
</div>
<div #section
    id="coverageAlerts"
    class="agpr-userPreferences-subSection"
>
    <h4 class="agpr-userPreferences-subSection-heading">
        {{ 'UserPreferences.coverageAlerts' | localize}}
    </h4>

    <div class="agpr-userPreferences-subSection-content">
        <agpr-user-preference-filter-wrapper
            [id]="'monitor_userPreferences_alerts_filters'"
            [items]="alerts"
            [initialValues]="monitoringPreferences.coverageAlertsPrefs.defaultFilters"
            [defaultFilters]="defaultAlertsFilters"
            (filterChange)="updateDirtyFlag()"
        ></agpr-user-preference-filter-wrapper>
    </div>
</div>

<div #section
    *ngIf="hasSubscriptionPermissions"
    id="subscriptions"
    class="agpr-userPreferences-subSection"
>
    <h4 class="agpr-userPreferences-subSection-heading">
        {{ 'UserPreferences.subscriptions' | localize}}
    </h4>
    <div class="agpr-userPreferences-subSection-content">
        <h5 class="agpr-userPreferences-subSection-subHeading">
            {{'AccountPreferences.defaultResults' | localize}}
        </h5>
        <div class="agpr-monitorPreferences-results-check">
            <div class="agpr-monitorPreferences-results-radio">
                <h6 class="agpr-monitorPreferences-results-dropdown-label"> {{ 'Monitor.userPreferences.defaultSearch.defaultViewMode' | localize }} </h6>
                <agpr-radio
                    [id]="'monitor_userPreferences_subscriptions_viewMode_analytics'"
                    label="Monitor.userPreferences.defaultSearch.defaultViewMode.analytics"
                    [(ngModel)]="subscriptionDisplaySettings.resultsViewMode"
                    [value]="resultsViewModeEnum.DASHBOARD"
                    (ngModelChange)="updateDirtyFlag()"
                ></agpr-radio>
                <agpr-radio
                    [id]="'monitor_userPreferences_subscriptions_viewMode_mentionFeed'"
                    [(ngModel)]="subscriptionDisplaySettings.resultsViewMode"
                    label="Monitor.userPreferences.defaultSearch.defaultViewMode.mention"
                    [value]="resultsViewModeEnum.MENTION"
                    (ngModelChange)="updateDirtyFlag()"
                ></agpr-radio>
            </div>
        </div>

    </div>
    <div class="agpr-userPreferences-subSection-content">
        <agpr-user-preference-filter-wrapper
            [id]="'monitor_userPreferences_subscriptions_filters'"
            [items]="mediaSubscriptions"
            [initialValues]="monitoringPreferences.subscriptionsPrefs.defaultFilters"
            [defaultFilters]="defaultSubscriptionsFilters"
            (filterChange)="updateDirtyFlag()"
        ></agpr-user-preference-filter-wrapper>
    </div>
</div>
